import { Link } from '@atlassian/search-dialog';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N500, N20, N30 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var MoreFiltersLink = styled(Link)({
  display: 'block',
  textAlign: 'center',
  borderRadius: '3px',
  color: "var(--ds-text-subtle, ".concat(N500, ")"),
  cursor: 'pointer',
  padding: "var(--ds-space-075, 6px)",
  backgroundColor: "var(--ds-background-neutral, ".concat(N20, ")"),
  transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
  '&:hover': {
    color: "var(--ds-text-subtle, ".concat(N500, ")"),
    backgroundColor: "var(--ds-background-neutral-hovered, ".concat(N30, ")"),
    textDecoration: 'none',
    transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
  },
  '&:visited': {
    color: "var(--ds-text-subtle, ".concat(N500, ")")
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var MoreFiltersContainer = styled.div({
  paddingTop: "var(--ds-space-400, 28px)"
});